"use strict";

var _regeneratorRuntime = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createQueue(callsPerSec) {
  var _this = this;

  var queue = [];
  var interval = setInterval(function () {
    if (queue.length !== 0) {
      var handler = queue.shift();
      if (handler) handler();
    }
  }, 1000 / callsPerSec);
  return {
    run: function run(handler) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve) {
                  return queue.push(resolve);
                });

              case 2:
                return _context.abrupt("return", handler());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    stop: function stop() {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                clearInterval(interval);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  };
}

exports.createQueue = createQueue;

function delay(ms) {
  return new Promise(function (resolve) {
    return setInterval(resolve, ms);
  });
}

exports.delay = delay;